<main id="externalUserCompId">
  <app-header></app-header>
  <app-announcement></app-announcement>
  <p-confirmDialog></p-confirmDialog>
  <div #divCt class="fluid-container blw_headermain">
      <!-- tab starts here -->
      <div class="row">
          <div class="col-12 internal_main" id="exTab1">
              <ul class="nav nav-pills nav_main" role="tablist">
                  <li class="nav-item"  id="id1">
                      <a class="nav-link" style="cursor: pointer;"
                          [ngClass]="(hideOrderInvoice==true)?'OrderInvoice-hide':'OrderInvoice-unhide'"
                          [class.active]="activeTab === 'invoice'" (click)="activeTab = 'invoice'; showInvoice(); setActiveTab('invoice')"
                          role="tab">Invoice</a>
                  </li>
                  <li class="nav-item" id="id2">
                      <a class="nav-link" style="cursor: pointer;"
                          [ngClass]="(hideOrderInvoice==true)?'OrderInvoice-hide':'OrderInvoice-unhide'"
                          [class.active]="activeTab === 'orders'" (click)="activeTab = 'orders'; OrdersTab();setActiveTab('orders')"
                          role="tab">Orders</a>
                  </li>
                  <li class="nav-item" id="id3">
                      <a class="nav-link" style="cursor: pointer;" 
                      [class.active]="activeTab === 'advance'"
                          (click)="activeTab = 'advance'; onAdvanceClick(); setActiveTab('advance')" role="tab">Advance Payment</a>
                  </li>
              </ul>
              <div class="tab-content clearfix">
                  <div id="1a" *ngIf="activeTab === 'invoice'">
                      <div class="user_main">
                          <a>
                              <button type="button" class="btn transaction_btn"
                                  (click)="GetTransaction()">Transactions
                                  <img src="/assets/images/transaction_icon.png">
                              </button>
                          </a>
                      </div>
                      <!-- pTable start here  -->
                      <!-- <div class="row clearfix" style="display: block;">
                          <div class="col-md-6 col-sm-6 col-xs-12">
                              <div class="agencyDropdown">
                                  <p-select [options]="AgencyDetail" name="state" [style]="{'width':'100%'}"
                                      [(ngModel)]="selectedUserAgency" placeholder="Select Agency"
                                      optionLabel="agencyName" appendTo="body"
                                      (ngModelChange)="UserAgencyFilterInvoice(selectedUserAgency)"></p-select>
                              </div>
                          </div> -->

                        <!-- pTable start here  -->
                             <div class="row">
                            <div class="col-12 sm:col-6 md:col-6">
                              <div class="agencyDropdown">
                                <p-select 
                                [style]="{'width':'100%'}"
                                  [options]="AgencyDetail" 
                                  name="state" 
                                  class="w-full"
                                  [(ngModel)]="selectedUserAgency" 
                                  placeholder="Select Agency"
                                  optionLabel="agencyName" 
                                  appendTo="body"
                                  (ngModelChange)="UserAgencyFilterInvoice(selectedUserAgency)">
                                  <ng-template pTemplate="selectedItem" let-selectedOption>
                                    {{ selectedOption?.agencyName }}
                                  </ng-template>
                                  <ng-template pTemplate="item" let-option>
                                    {{ option.agencyName }}
                                  </ng-template>
                                </p-select>
                              </div>
                            </div>
                          
                          <div class="col-12 sm:col-6 md:col-6">
                              <div class="searchmain">
                                  <input id="InvoiceGlobalSearch"#gb type="text" placeholder="Search Alphanumeric values here..."
                                      class="search_box" [(ngModel)]="globalFilterFields" (input)="dt.filterGlobal($event.target.value, 'contains')" />
                                      
                                  <i class="fa fa-search search_icon"></i>
                              </div>

                          </div>
                          <div class="col-12 lg:col-6 mb-2">
                            Below is a list of your invoices. Select an invoice by clicking the box at the left to make a payment. 
                            To view a copy of the invoice, click the icon to the right.
                          </div>
                      </div>
                      <div id="externalUserTable">
                          <p-table #dt [value]="Invoice" [ngClass]="{filter: isFilterEnable}" [rows]="20"
                              [paginator]="true" [pageLinks]="10" [globalFilterFields]="['invoiceID', 'invoiceDate', 'invoiceDateSortable', 'agencyName',
                              'invoiceDueDate', 'invoiceDueDateSortable', 'previousBalanceAmt', 'invoiceAmount',
                              'advertiserName', 'advertiserId', 'orderId', 'estimateNumber', 'propertyOrStationName',
                              'createdDate', 'chaseStatus', 'status', 'paymentTransType', 'sapCompanyCode', 'agencyCommission'
                              ]"
                              [reorderableColumns]="true" [resizableColumns]="false" [loading]="loadingInvoice"
                              (onRowSelect)="onInvoiceRowSelect($event)"
                              (onRowUnselect)="onRowInvoiceUnselect($event)" emptyMessage="'No Invoice Available'"
                              (onHeaderCheckboxToggle)="invoiceHeaderCheckBoxToggle(selectedItems)"
                              [(selection)]="selectedItems" selectionMode="multiple"
 
                              [tableStyle]="{'font-size':'12px','table-layout':'inherit','width':'100%','border-collapse': 'collapse','border': '1px solid #c5c5c5'}"
                              [responsiveLayout]="'scroll'">
                              <!-- Define columns here, example: -->
                              <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 60px;">
                                        <div class="flex flex-column align-items-center">
                                          <!-- Checkbox -->
                                          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                  
                                          <!-- Filter icon below (or side by side if you want) -->
                                          <i (click)="invoiceFilterToggle($event)" 
                                             class="fa fa-fw fa-filter cursorpointer mt-1"></i>
                                        </div>
                                      </th>
                                  
                                  
                                      <!--  Arvind Station Name   -->
                                   
                                    <th pResizableColumn pReorderableColumn>
                                        <span style="font-weight: bold;">Station</span>
                                    </th>
                                    
                                      <!-- Invoice ID -->
                                      <th pResizableColumn pReorderableColumn>
                                          <span style="font-weight: bold;">Invoice ID</span>
                                          <!-- <p-columnFilter field="invoiceID" [showMenu]="false"
                                              [disabled]="!enableInvoiceFilter">
                                          </p-columnFilter> -->
                                      </th>

                                      <!-- Estimate Number -->
                                      <th pResizableColumn pReorderableColumn>
                                          <span style="font-weight: bold;">Estimate<br />Number</span>
                                          <!-- <p-columnFilter field="estimateNumber" [showMenu]="false"
                                              [disabled]="!enableInvoiceFilter">
                                          </p-columnFilter> -->
                                      </th>

                                      <!-- Invoice Date, Arvind Flight start date , 08/13/2018 remove Flight start date from  Invoice/Flight Start Date-->
                                      <th pResizableColumn pReorderableColumn pSortableColumn="invoiceDateSortable">
                                          <span style="font-weight: bold;">Invoice Date</span>
                                          <p-columnFilter field="invoiceDateSortable" [showMenu]="false"
                                              [disabled]="!enableInvoiceFilter" display="menu">
                                              <ng-template pTemplate="filter" let-filter>
                                                  <input type="text" class="form-control dateRangeFilter"
                                                      (ngModelChange)="dt.filter($event, 'invoiceDateSortable', 'contains')"
                                                      [(ngModel)]="filter.value" pInputText
                                                      placeholder="Filter by date">
                                              </ng-template>
                                          </p-columnFilter>
                                      </th>

                                      <th pResizableColumn pReorderableColumn pSortableColumn="agencyName">
                                          <span style="font-weight: bold;">Agency</span>
                                          <!-- <p-columnFilter field="agencyName" [showMenu]="false"
                                              [disabled]="!enableInvoiceFilter">
                                          </p-columnFilter> -->
                                      </th>
                                      <!-- Advertiser Name -->
                                      <th pResizableColumn pReorderableColumn pSortableColumn="advertiserName">
                                          <span style="font-weight: bold;">Advertiser</span>
                                          <!-- <p-columnFilter field="advertiserName" [showMenu]="false"
                                              [disabled]="!enableInvoiceFilter">
                                          </p-columnFilter> -->
                                      </th>

                                      <!-- Invoice Due Date -->
                                      <th pResizableColumn pReorderableColumn
                                          pSortableColumn="invoiceDueDateSortable">
                                          <span style="font-weight: bold;">Due Date</span>
                                          <p-columnFilter field="invoiceDueDateSortable" [showMenu]="false"
                                              [disabled]="!enableInvoiceFilter" display="menu">
                                              <ng-template pTemplate="filter" let-filter>
                                                  <input type="text" class="form-control dateRangeFilter"
                                                      (ngModelChange)="dt.filter($event, 'invoiceDueDateSortable', 'contains')"
                                                      [(ngModel)]="filter.value" pInputText
                                                      placeholder="Filter by due date">
                                              </ng-template>
                                          </p-columnFilter>
                                      </th>

                                    
                                      <!-- Invoice Amount -->
                                      <th pResizableColumn pReorderableColumn pSortableColumn="invoiceAmount"
                                          class="amountInvFilter width177" [style]="{'font-weight': 'bold'}">
                                          <span>Original Invoice Amount<br /> (Cash Discount Price) $</span>
                                          <!-- <p-columnFilter field="invoiceAmount" [showMenu]="false"
                                              [disabled]="!enableInvoiceFilter">
                                          </p-columnFilter> -->
                                      </th>

                                        <!-- Previous Balance Amount -->
                                        <th pResizableColumn pReorderableColumn pSortableColumn="BalanceAmt"
                                        class="amountInvFilter width180" [style]="{'font-weight': 'bold'}">
                                        <span>Invoice Balance<br /> (Cash Discount Price) $</span>
                                        <!-- <p-columnFilter field="previousBalanceAmt" [showMenu]="false"
                                            [disabled]="!enableInvoiceFilter">
                                        </p-columnFilter> -->
                                    </th>

                                      <!--Payment Status-->
                                      <th pResizableColumn pReorderableColumn>
                                          <span style="font-weight: bold;">Payment Status</span>
                                      </th>

                                      <!-- <th pResizableColumn pReorderableColumn>
                                          <span style="font-weight: bold;">Preview</span>
                                      </th> -->
                                      <th style="width:50px;"></th>

                                  </tr>
                              </ng-template>
                              <ng-template pTemplate="body" let-rowData>
                                  <tr>
                                    <td>
                                        <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                                    </td>
                                      <td>
                                          {{rowData.propertyOrStationName}}
                                      </td>
                                      <td>
                                          {{rowData.invoiceID}}
                                      </td>
                                      <td>
                                          {{rowData.estimateNumber}}
                                      </td>
                                      <td>
                                          {{rowData.invoiceDate}}
                                      </td>
                                      <td>
                                          {{rowData.agencyName}}
                                      </td>
                                      <td>
                                          {{rowData.advertiserName}}
                                      </td>
                                      <td>
                                          {{rowData.invoiceDueDate}}
                                      </td>
                                     
                                      <!-- Invoice Amount -->
                                      <td>
                                          <div>{{rowData.invoiceAmount | currency:'USD'}}</div>
                                      </td>

                                      <td>
                                        <div>{{rowData.previousBalanceAmt | currency:'USD'}}</div>
                                    </td>
                                      <!-- Payment Status -->
                                      <!-- <td>
                                          <div *ngIf="rowData.status=='Payment Processing'">
                                              <img src="/assets/images/processing.png"
                                                  matTooltip="Payment Processing" />
                                          </div>
                                      </td> -->
                                      <td>
                                        <div *ngIf="rowData.status=='Payment Processing'">
                                          <img src="/assets/images/processing.png" matTooltip="Payment Processing" />
                                        </div>
                                      </td>



                                    <td>
                                        <span class="pdfLink paddingL10" matTooltip="Preview" (click)="viewFile(rowData.invoiceID)">
                                            <i class="fa fa-file-pdf-o pdf cursorpointer"></i>
                                        </span>
                                    </td>
                                  </tr>
                              </ng-template>
                              <ng-template pTemplate="emptymessage">
                                  <tr>
                                      <td colspan="12" style="text-align: left;">No records found.</td>
                                  </tr>
                              </ng-template>
                          </p-table>
                      </div>
                      <!-- External User Table End -->
                      <!-- pTable End here  *ngIf="this.invoiceBtn" -->
                      <div class="pay_now" style="cursor: pointer;">
                          <button type="button" [disabled]="!invoiceBtn" (click)="InvoiceDetail($event)"
                              class="btn btn-success order_buttonicon">Continue to Payment Screen</button>
                      </div>
                  </div>
                  <!-- Invoice Tabs ends here -->
                  <!-- Orders tabs starts here -->
                  <div id="2a" *ngIf="activeTab === 'orders'">
                      <div class="user_main">
                          <a>
                              <button type="button" class="btn transaction_btn"
                                  (click)="GetTransaction()">Transactions
                                  <img src="/assets/images/transaction_icon.png">
                              </button>
                          </a>
                      </div>
                      <div id="externalUserTable2">
                          <div class="row marginNone">
                              <div class="col-md-6 col-sm-6 col-xs-12">
                                  <div class="agencyDropdown">
                                      <p-select [options]="AgencyDetail" name="state" [autoWidth]="false"
                                          [style]="{'width':'100%'}" [(ngModel)]="selectedUserAgency"
                                          placeholder="Select Agency" appendTo="body" optionLabel="agencyName"
                                          (ngModelChange)="UserAgencyFilterOrder(selectedUserAgency)"></p-select>
                                  </div>
                              </div>
                              <div class="col-md-6 col-sm-6 col-xs-12">
                                  <div class="searchmain">
                                      <input #ga type="text" placeholder="Search Alphanumeric values here..."
                                          class="search_box">
                                      <i class="fa fa-search search_icon"></i>
                                  </div>
                              </div>
                              <div class="col-lg-12" style="margin-bottom: 10px;float: left">Below is a list of your
                                  orders. Select an
                                  order by clicking the box at the left to make a payment. To view a copy of the
                                  order, click the icon
                                  to the right.
                              </div>
                          </div>
                          <!--order global search End here-->


                          <!--Order Table start here-->
                          <p-table #dtr [value]="Orders" [ngClass]="{filter: isFilterEnableOrder}"
                              [loading]="loadingOrder" [rows]="20" [paginator]="true" [pageLinks]="10"
                              [globalFilterFields]="['field1', 'field2']" [reorderableColumns]="true"
                              [resizableColumns]="true" emptyMessage="No Orders Available"
                              (onRowSelect)="onOrderRowSelect($event)" (onRowUnselect)="onRowOrderUnselect($event)"
                              (onHeaderCheckboxToggle)="orderHeaderCheckBoxToggle(selectedOrderItems)"
                              [(selection)]="selectedOrderItems"
                              [tableStyle]="{'font-size':'12px','table-layout':'inherit','width':'100%','border-collapse': 'collapse','border': '1px solid #c5c5c5'}"
                              [responsiveLayout]="'scroll'">
                              <ng-template pTemplate="header">
                                  <tr>
                                      <th style="width:38px;">
                                          <i (click)="ordersFilterToggle($event)"
                                              class="fa fa-fw fa-filter cursorpointer"></i>
                                      </th>
                                      <th pResizableColumn pReorderableColumn>
                                          <span style="font-weight: bold;">Invoice Detail</span>
                                      </th>

                                      <!-- station -->
                                      <th pResizableColumn pReorderableColumn pSortableColumn="station_name">
                                          <span style="font-weight: bold;">Stations</span>
                                          <!-- Vaibhav Added *ngIf="enableOrdersFilter" to hide/unihide filter based on click of filter icon -->
                                          <p-columnFilter *ngIf="enableOrdersFilter" field="station_name" [showMenu]="false"
                                              [disabled]="!enableOrdersFilter"></p-columnFilter>
                                      </th>
                                      <!-- Order ID -->
                                      <th pResizableColumn pReorderableColumn pSortableColumn="order_id">
                                          <span style="font-weight: bold;">Order ID</span>
                                          <p-columnFilter *ngIf="enableOrdersFilter" field="order_id" [showMenu]="false"
                                              [disabled]="!enableOrdersFilter"></p-columnFilter>
                                      </th>

                                      <!-- Order Date -->
                                      <th pResizableColumn pReorderableColumn
                                          pSortableColumn="flight_start_dt_sortable">
                                          <span style="font-weight: bold;">Flight Start Date</span>
                                          <p-columnFilter field="flight_start_dt_sortable" [showMenu]="false"
                                              [disabled]="!enableOrdersFilter" display="menu">
                                              <ng-template pTemplate="filter" let-filter>
                                                  <input type="text" class="form-control dateRangeFilter"
                                                      (ngModelChange)="dtr.filter($event, 'flight_start_dt_sortable', 'contains')"
                                                      [(ngModel)]="filter.value" pInputText
                                                      placeholder="Filter by date">
                                              </ng-template>
                                          </p-columnFilter>
                                      </th>

                                      <!-- Agency -->
                                      <th pResizableColumn pReorderableColumn pSortableColumn="agencyName">
                                          <span style="font-weight: bold;">Agency</span>
                                          <p-columnFilter field="agencyName" [showMenu]="false"
                                              [disabled]="!enableOrdersFilter"></p-columnFilter>
                                      </th>
                                      <th pResizableColumn pReorderableColumn pSortableColumn="advertiser_name"
                                          class="width270">
                                          <span style="font-weight: bold;">Advertiser</span>
                                          <p-columnFilter field="advertiser_name" [showMenu]="false"
                                              [disabled]="!enableOrdersFilter"></p-columnFilter>
                                      </th>

                                      <th pResizableColumn pReorderableColumn pSortableColumn="total_order_amount"
                                          class="amountFilter width180" [style]="{'font-weight': 'bold'}">
                                          <span>Order Total<br /> (Cash Discount Price) $</span>
                                          <p-columnFilter field="total_order_amount" [showMenu]="false"
                                              [disabled]="!enableOrdersFilter"></p-columnFilter>
                                      </th>

                                      <th pResizableColumn pReorderableColumn>
                                          <span style="font-weight: bold;">Preview</span>
                                      </th>

                                  </tr>
                              </ng-template>
                              <ng-template pTemplate="body" let-rowData>
                                  <td>
                                      <div style="cursor:pointer">
                                          <a>
                                              <i matTooltip="Invoice Detail" class="fa fa-info info_icon"
                                                  data-toggle="modal" data-target="#myModal"
                                                  (click)="GetOrderInvoiceClick(rowData.order_id, rowData.invoice_flag)"></i>
                                          </a>
                                      </div>
                                  </td>
                                  <td>
                                      {{rowData.station_name}}
                                  </td>
                                  <td>
                                      {{rowData.order_id}}
                                  </td>
                                  <td>
                                      {{rowData.flight_start_dt}}
                                  </td>
                                  <td>
                                      {{rowData.agencyName}}
                                  </td>
                                  <td>
                                      {{rowData.advertiser_name}}
                                  </td>
                                  <td>
                                      <div>{{rowData.total_order_amount | currency:'USD'}}</div>
                                  </td>
                                  <td>
                                      <span class="pdfLink paddingL10" matTooltip="Preview"
                                          (click)="viewFile(rowData.order_id)">
                                          <i class="fa fa-file-pdf-o pdf cursorpointer"></i>
                                      </span>
                                  </td>x
                              </ng-template>
                              <ng-template pTemplate="emptymessage">
                                  <tr>
                                      <td colspan="9" style="text-align: left;">No records found.</td>
                                  </tr>
                              </ng-template>
                          </p-table>
                      </div>
                      <!-- Order Ptable start here  *ngIf="this.orderBtn"-->
                      <div class="pay_now">
                          <button type="button" [disabled]="!orderBtn" (click)="OrderDetail($event)"
                              class="btn btn-success order_buttonicon">Continue to Payment Screen
                          </button>
                      </div>
                  </div>
                  <!-- Orders tabs ends here -->
                  <!-- advance pay starts here -->
                  <div id="3a" *ngIf="activeTab === 'advance'">
                      <div class="user_main">
                          <a>
                              <button type="button" class="btn transaction_btn"
                                  (click)="GetTransaction()">Transactions
                                  <img src="/assets/images/transaction_icon.png">
                              </button>
                          </a>
                      </div>
                      <!-- Advance payment Table Starts here -->
                      <div class="no-more-tables">
                          <form #myForm="ngForm">
                              <table class="round_table cf advancePaymentTbl tableFixed">
                                  <thead class="cf">
                                      <tr>
                                          <th><span class="redText">*</span>Account Executive</th>
                                          <!-- Arvind Added Agency for Advance page -->
                                          <th><span class="redText">*</span>Agency</th>
                                          <th><span class="redText">*</span>Comments</th>
                                          <th></th>
                                      </tr>
                                  </thead>
                                  <!--  -->
                                  <tr>
                                      <td data-title="Account Executive">
                                          <div id="accountExecutiveDD" *ngIf=accountFlag>
                                              <p-select [options]="accountExecutives" [autoWidth]="false"
                                                  appendTo="body" [(ngModel)]="accountExtxt"
                                                  placeholder="Select Account Executive" name="accountEx"
                                                  optionLabel="name">
                                                <ng-template pTemplate="selectedItem" let-selectedOption>
                                                  {{ selectedOption?.name }}
                                                </ng-template>
                                                <ng-template pTemplate="item" let-option>
                                                  {{ option.name }}
                                                </ng-template>
                                              </p-select>
                                          </div>

                                          <div>
                                              <span [hidden]="invalidAccountEx" class="input-ErrorField">Account
                                                  Executive Required</span>
                                          </div>
                                      </td>
                                      <!-- arvind agency in Advance page -->
                                      <td data-title="Agency">
                                          <div class="agencyDropdown">
                                              <p-select [options]="AgencyDetail" name="state" [autoWidth]="false"
                                                  [style]="{'width':'100%'}" [(ngModel)]="selectedUserAgency"
                                                  placeholder="Select Agency" name="agencydetail"
                                                  optionLabel="agencyName" appendTo="body"
                                                  (ngModelChange)="UserAgencyFilterInvoice(selectedUserAgency)"></p-select>
                                          </div>
                                          <div>
                                              <span [hidden]="invalidAgency" class="input-ErrorField">Agency
                                                  Required</span>
                                          </div>
                                      </td>
                                      <td data-title="Comments">

                                          <div>
                                              <textarea required rows="4" cols="50" class="form-control width270"
                                                  [(ngModel)]="commentstxt" name="comments" #comments="ngModel"
                                                  maxlength="1300">
                                              </textarea>
                                          </div>

                                          <div>
                                              <span [hidden]="invalidComments" class="input-ErrorField">Invalid
                                                  Comments</span>
                                          </div>
                                      </td>
                                      <td></td>
                                  </tr>
                              </table>
                          </form>
                          <br />
                          <button type="button" (click)="addStation()" class="btn add_internaluserbtn">Add Station
                              <span class="glyphicon glyphicon-plus"></span>
                          </button>
                          <!-- Add Station  start -->

                          <div [hidden]="!ShowaddStation">
                              <br />
                              <form #addStationForm="ngForm" (ngSubmit)="onAddStationClick(addStationForm)">
                                  <table class="round_table cf advancePaymentTbl tableFixed">
                                      <thead class="cf">
                                          <tr>
                                              <th>
                                                  <span class="redText">*</span>Station
                                              </th>
                                              <th>
                                                  <!-- Arvind change to Gross Cash Discount Price from Net Gross Regular Amount $ -->
                                                  <span class="redText">*</span>Gross Cash Discount Price
                                              </th>
                                              <th></th>
                                          </tr>
                                      </thead>
                                      <tr>

                                          <td data-title="Station">
                                              <div>
                                                  <p-select id="stationDD" [options]="stations" [autoWidth]="false"
                                                      appendTo="body" [(ngModel)]="stationtxt"
                                                      placeholder="Select Station" name="station"
                                                      optionLabel="stationName">
                                                  </p-select>
                                              </div>

                                              <div>
                                                  <span [hidden]="invalidStation" class="input-ErrorField">Station
                                                      Required</span>
                                              </div>
                                              <div *ngIf="isStationExist">
                                                  <span class="input-ErrorField">Station already Exists!</span>
                                              </div>

                                          </td>

                                          <td data-title="Gross Cash Discount Price">
                                              <!-- <div class="editable" *ngIf="data.isEditable"> -->
                                              <input currencyMask pInputText pKeyFilter="money" on-paste="false"
                                                  type="text" autocomplete="off" required
                                                  placeholder="Enter Gross Cash Discount Price"
                                                  [(ngModel)]="amounttxt" class="form-control width300 width270"
                                                  name="amount" #amount="ngModel" maxlength="15"
                                                  style="font-size:14px" />

                                              <div>
                                                  <span [hidden]="invalidAdvanceAmnt" class="input-ErrorField">Invalid
                                                      Gross Cash Discount
                                                      Price</span>
                                              </div>

                                              <div>
                                                  <span [hidden]="exceededAdvanceAmnt" class="input-ErrorField">Please
                                                      enter an Gross Cash
                                                      Discount Price less than $ 10,000,000.00</span>
                                              </div>
                                              <!-- </div> *ngIf="data.isEditable=='undefined'|| data.isEditable==false" -->
                                          </td>
                                          <td>
                                              <div>
                                                  <span>
                                                      <button type="submit"
                                                          class="btn btn-success submit_buttonicon btnSubmit">
                                                          <i class="fa fa-check"></i> Submit
                                                      </button>
                                                  </span>
                                                  <span>
                                                      <button type="button"
                                                          (click)="showAddstationClose();myForm.reset()"
                                                          class="btn btn-success cancel_btncancel btncancel">
                                                          <i class="fa fa-remove"></i> Cancel</button>
                                                  </span>
                                                  <div>
                                                      &nbsp;
                                                  </div>

                                              </div>


                                          </td>

                                      </tr>

                                  </table>

                              </form>
                          </div>
                          <!-- Add Station Ends-->
                          <br />
                          <br />
                          <div id="app-uneditable-table">
                              <p-table [value]="StationList" [reorderableColumns]="true" [resizableColumns]="false"
                                  [tableStyle]="{'width':'100%','border-collapse': 'collapse','border': '1px solid #c5c5c5','min-width':'830px'}"
                                  [responsiveLayout]="'scroll'" emptyMessage="No Station Available">
                                  <ng-template pTemplate="header">
                                      <tr>
                                          <th style="font-weight:900;">Station</th>
                                          <th style="font-weight:900;text-align: center;">Gross Cash Discount Price</th>
                                          <th style="font-weight:900;">Action</th>
                                      </tr>
                                  </ng-template>
                                  <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
                                      <tr>
                                          <td>
                                            <div *ngIf="!rowData.isEditable">
                                                {{ rowData.station?.stationName || '' }}
                                            </div>
                                            <div *ngIf="rowData.isEditable">
                                                <p-select 
                                                    [options]="stations" 
                                                    [(ngModel)]="rowData.station" 
                                                    optionLabel="stationName"
                                                    placeholder="Select Station"
                                                    name="editStation"
                                                    appendTo="body"
                                                    [autoWidth]="false">
                                                </p-select>
                                            </div>
                                              <div *ngIf="isStationExistInGrid">
                                                  <span class="input-ErrorField">Station already Exists!</span>
                                              </div>
                                          </td>
                                          

                                          <td style="text-align: center;">
                                            <div *ngIf="!rowData.isEditable">
                                                {{ rowData.amount | currency:'USD' }}
                                            </div>
                                            <div *ngIf="rowData.isEditable">
                                                <input type="text"
                                                       pInputText
                                                       [(ngModel)]="rowData.amount"
                                                       class="form-control width300 width270"
                                                       name="editAmount"
                                                       maxlength="15"
                                                       style="font-size:14px"
                                                       currencyMask
                                                       pKeyFilter="money"
                                                       autocomplete="off"
                                                       placeholder="Enter Gross Cash Discount Price" />
                                            </div>
                                              
                                              <div>
                                                  <span [hidden]="invalidAdvanceAmntInGrid" class="input-ErrorField">
                                                      Invalid Gross Regular Amount
                                                  </span>
                                              </div>
                                              <div>
                                                  <span [hidden]="exceededAdvanceAmntInGrid" class="input-ErrorField">
                                                      Please enter a Gross regular amount less than $ 10,000,000.00
                                                  </span>
                                              </div>
                                          </td>

                                          <!-- Action - Edit -->
                                        <td>
                                            <div>
                                                <span>
                                                    <button pButton type="button" icon="fa fa-pencil" class="ui-button-success"
                                                        [pTooltip]="disableINeditBtn ? null : 'Edit'"
                                                        (click)="onRowEditSelect(rowData, addStationForm)"
                                                        [disabled]="disableINeditBtn"></button>
                                                    <button pButton type="button" icon="fa fa-trash" class=" ui-button-danger"
                                                        [pTooltip]="disableINdeleteBtn ? null : 'Delete'"
                                                        (click)="onRowINdeleteSelect(rowData)"
                                                        [disabled]="disableINdeleteBtn"></button>
                                                    <button pButton type="button" icon="fa fa-check" class="btn p-button-success ui-button-success"
                                                        pTooltip="Save"
                                                        *ngIf="rowData.isEditable"
                                                        (click)="onUpdateStationRowClick(rowData, rowIndex)"
                                                        [disabled]="disableINUpdateBtn"></button>
                                                    <button pButton type="button" icon="fa fa-close" class="btn btn-danger ui-button-danger"
                                                        pTooltip="Cancel"
                                                        *ngIf="rowData.isEditable"
                                                        (click)="onCancelRowClick(rowData)"></button>
                                                </span>
                                            </div>
                                        </td>
                                        
                                      </tr>
                                  </ng-template>
                                  <ng-template pTemplate="emptymessage">
                                      <tr>
                                          <td colspan="3">No Station Available</td>
                                          
                                      </tr>
                                  </ng-template>
                              </p-table>
                          </div>
                          <p-table id="totalAmtTable" [tableStyle]="{'border': '1px solid #c5c5c5'}"
                              [responsiveLayout]="'scroll'">
                              <ng-template pTemplate="header">
                                  <tr>
                                      <th class="totalAmtTable">
                                          Total Amount {{SumStationAmount | currency:'USD'}}
                                      </th>
                                      <th></th>
                                  </tr>
                              </ng-template>
                          </p-table>
                      </div>
                      <div class="checkbox checkbox_main" style="margin-left:25%; position: relative;"
                          [hidden]="!ShowTaxCheckBox">
                          <span class="full_payment" style="margin-left: 10px"> {{message}} </span>
                      </div>
                      <!-- Arvind Added check box for TAX calculation in ng-init="isTaxChecked=false"-->
                      <div class="checkbox checkbox_main" style="margin-left: 78%; position: relative;"
                          [hidden]="!ShowTaxCheckBox">
                          <input type="checkbox" [disabled]="isSelectedMultipleInovice" [(ngModel)]="isTaxChecked"
                              name="taxcheckbox" value="FullTaxPayment" class="checkbox_modified"
                              [checked]="isTaxCheckedBOX" (change)="onTaxChecked($event)">
                          <span class="full_payment" style="margin-left: 19px"> Add Tax</span>
                      </div>

                      <!-- Arvind Added check box for Agnecy Commission in -->
                      <!-- [(ngModel)]='isChecked' -->
                      <div class="checkbox checkbox_main"
                          style="margin-left: 88%; position: relative; margin-top:-28px;">
                          <input type="checkbox" [disabled]="isSelectedMultipleInovice" [(ngModel)]="isCheckedAgency"
                              name="comissioncheckbox" value="FullPayment" class="checkbox_modified"
                              [checked]="isCheckedBOX" (change)="onChecked($event)">
                          <span class="full_payment" style="margin-left: 19px"> Add Agency Commission</span>
                      </div>
                      <div class="pay_now" [hidden]="!ShowpaynowBtn">
                          <button (click)="onAdvancePaymentPayNow()" type="button"
                              class="btn btn-success order_buttonicon">Continue
                              to Payment Screen</button>
                      </div>
                  </div>
                  <!-- advance pay ends here -->
              </div>
          </div>
      </div>
  </div>
</main>

<div class="modal fade invoiceDetailModal" id="myModal" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Invoice Detail of Order ID {{OrderRelatedInvoiceId}}</h5>
              <button type="button" class="btn-close close_btn" id="close" data-bs-dismiss="modal"
                  aria-label="Close"></button>
          </div>
          <div class="modal-body" *ngIf="IsinvoicedFlag == true">
              <div class="col-lg-12" style="margin-bottom: 10px;float: left">Below is a list of your invoices. Select
                  an
                  invoice by clicking the box at the left to make a payment. To view a copy of the invoice, click the
                  icon to
                  the right.
              </div>
              <div id="orderInvoiceTable">
                  <p-table class="tableFixed" #dordert [value]="OrderInvoice" [rows]="8" [paginator]="true" [pageLinks]="10"
                      [reorderableColumns]="true" [resizableColumns]="false" [loading]="loadingOrderInvoicepopup"
                      (onRowSelect)="onOrderInvoiceRowSelect($event)" (onRowUnselect)="onRowOrderInvoiceUnselect($event)"
                      emptyMessage="No Invoice Available"
                      (onHeaderCheckboxToggle)="orderInvoiceHeaderCheckBoxToggle(selectedOrderInvoiceItems)"
                      [(selection)]="selectedOrderInvoiceItems"
                      [tableStyle]="{'width':'100%','border-collapse': 'collapse','border': '1px solid #c5c5c5'}"
                      [responsiveLayout]="'scroll'">
                      <ng-template pTemplate="header">
                          <tr>
                              <!-- Add your column headers here -->
                              <th>Station</th>
                              <th>Invoice ID</th>
                              <th>Estimate Number</th>
                              <th>Invoice Date</th>
                              <th>Agency</th>
                              <th>Advertiser</th>
                              <th>Due Date</th>
                              <th>Prev. Balance (Cash Discount Price) $</th>
                              <th>Invoice Total (Cash Discount Price) $</th>
                              <th>Payment Status</th>
                              <th>Preview</th>
                          </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-rowData>
                          <tr>
                              <td>{{rowData.propertyOrStationName}}</td>
                              <td>{{rowData.invoiceID}}</td>
                              <td>{{rowData.estimateNumber}}</td>
                              <td>{{rowData.invoiceDate}}</td>
                              <td>{{rowData.agencyName}}</td>
                              <td>{{rowData.advertiserName}}</td>
                              <td>{{rowData.invoiceDueDate}}</td>
                              <td>{{rowData.previousBalanceAmt | currency:'USD'}}</td>
                              <td>{{rowData.invoiceAmount | currency:'USD'}}</td>
                            <td>
                                <div *ngIf="rowData.status=='Payment Processing'">
                                    <img src="/assets/images/processing.png" matTooltip="Payment Processing" />
                                </div>
                            </td>
                            <td>
                                <span class="pdfLink paddingL10" matTooltip="Preview" (click)="viewFile(rowData.invoiceID)">
                                    <i class="fa fa-file-pdf-o pdf cursorpointer"></i>
                                </span>
                            </td>
                          </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                          <tr>
                              <td colspan="11" style="text-align: left;">No records found.</td>
                          </tr>
                      </ng-template>
                  </p-table>
              </div>
              <div class="pay_now">
                  <button type="button" [disabled]="!orderInvoiceBtn" (click)="OrderInvoiceDetail($event)"
                      class="btn btn-success order_buttonicon" data-dismiss="modal">Continue to Payment
                      Screen</button>
              </div>
          </div>
          <div class="modal-body" *ngIf="IsinvoicedFlag == false" style="color: red">
              <!-- Not an invoiced Order.-->
              <!-- Invoice flag NO for the selected Order -->
              No Invoice Available
          </div>
      </div>
  </div>
</div>


<p-dialog header="PDF" class="InvoicePDF" [(visible)]="display" modal="modal" [responsive]="true" [width]="800"
  [blockScroll]="true">
  <div *ngIf="showIframe">
      <iframe width="100%" height="500" [src]="urlSafe"></iframe>
  </div>

  <div *ngIf="fileNotFound">
      <label>File Not Found!</label>
  </div>

  <div id="fileLoader" *ngIf="fileLoading">
      <!-- <label>File loading! Please wait!</label> -->
      <p-progressSpinner [style]="{width: '70px', height: '70px'}"></p-progressSpinner>
  </div>

</p-dialog>